export default function BlockchainIcon({
  size = 'w-[26px] h-[26px]',
  color = 'white',
}) {
  return (
    <svg
      className={size}
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.6922 17.9795V8.02468C22.6915 7.88088 22.6528 7.73983 22.5801 7.61575C22.5074 7.49168 22.4033 7.38895 22.2783 7.31794L13.3937 2.32035C13.274 2.25123 13.1382 2.21484 12.9999 2.21484C12.8617 2.21484 12.7259 2.25123 12.6062 2.32035L3.72156 7.31794C3.59652 7.38895 3.49241 7.49168 3.41974 7.61575C3.34706 7.73983 3.30839 7.88088 3.30762 8.02468V17.9795C3.30839 18.1233 3.34706 18.2643 3.41974 18.3884C3.49241 18.5125 3.59652 18.6152 3.72156 18.6862L12.6062 23.6838C12.7259 23.7529 12.8617 23.7893 12.9999 23.7893C13.1382 23.7893 13.274 23.7529 13.3937 23.6838L22.2783 18.6862C22.4033 18.6152 22.5074 18.5125 22.5801 18.3884C22.6528 18.2643 22.6915 18.1233 22.6922 17.9795V17.9795Z"
        stroke={color}
        strokeWidth="0.807692"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.5812 7.60938L13.0908 13.0007L3.4187 7.60938"
        stroke={color}
        strokeWidth="0.807692"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0909 13L13 23.7827"
        stroke={color}
        strokeWidth="0.807692"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9471 4.875L13 7.66154L8.05286 4.875"
        stroke={color}
        strokeWidth="0.807692"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8462 21.1796V15.6166L22.6923 12.8906"
        stroke={color}
        strokeWidth="0.807692"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.15377 21.1796V15.6166L3.30762 12.8906"
        stroke={color}
        strokeWidth="0.807692"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
